// extracted by mini-css-extract-plugin
export var csatScore = "_o0-5";
export var header = "_o0-1";
export var panelWrapper = "_o0-2";
export var postPreview = "_o0-3";
export var rightContent = "_o0-0";
export var wrappingText = "_o0-4";